import React from 'react';
import { Helmet } from 'react-helmet-async';

import { categories } from '../../data/categories';
import { HomePageMetaProps } from './HomePage.types';

export const HomePageMeta: React.FC<HomePageMetaProps> = ({ categoryId }) => {
    if (!categoryId) {
        return null;
    }

    const category = categories.find(c => c.id === categoryId);

    if (!category) {
        return null;
    }

    const title = `${category.name} - Готовые промпты и курсы для Алисы AI и других нейросетей`;
    const description = `Промпты в категории «${category.name}». Подберите для себя подходящий промпт вместе с Алиса AI`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
        </Helmet>
    );
};
